import { Configuration, PublicClientApplication, LogLevel } from '@azure/msal-browser';

// Placeholder values so the app can still boot (e.g. in auth-bypass local dev)
// even if the AAD env vars are not configured.
const fallbackClientId = '00000000-0000-0000-0000-000000000000';
const fallbackTenantId = 'common';
const fallbackScope = 'api://00000000-0000-0000-0000-000000000000/access_as_user';

const clientId = import.meta.env.VITE_AAD_CLIENT_ID || fallbackClientId;
const tenantId = import.meta.env.VITE_AAD_TENANT_ID || fallbackTenantId;
const apiScope = import.meta.env.VITE_API_SCOPE || fallbackScope;

/** MSAL configuration for the management SPA's Azure AD (Entra ID) app registration. */
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: import.meta.env.VITE_AAD_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_AAD_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (_level, message, containsPii) => {
        if (!containsPii) {
          // eslint-disable-next-line no-console
          console.debug(message);
        }
      },
    },
  },
};

/** Scopes requested when acquiring an access token for the API. */
export const apiRequest = {
  scopes: [apiScope],
};

/** Scopes requested at login. */
export const loginRequest = {
  scopes: ['openid', 'profile', apiScope],
};

/** Singleton MSAL client instance used throughout the app for auth operations. */
export const msalInstance = new PublicClientApplication(msalConfig);
